<template>
    <div class="post">
        <div v-if="loading" class="loading">
            Loading...
        </div>
        <div v-if="error" class="notifications is-lightx">
            <NotFound />
        </div>
        <div v-if="post" class="box content blogpost" id="read">
            <nav class="level">
                <!-- Left side -->
                <div class="level-left">
                    <div class="level-item">
                        <h1 v-cloak class="title is-4">{{ post.title | capitalize }}</h1>
                    </div>
                </div>
                <!-- Right side -->
                <div class="level-right">
                    <span title="publié le" class="has-text-grey"><i class="fas fa-clock"></i> {{post.datepost | formatDate}}</span>
                </div>
            </nav>
            <p align="center"><img alt="img" v-if="post.image" :src="post.image.path" width="300" @error="imageUrlAlt"></p>
            <p  v-if="post.content" v-html="post.content"></p>
            <p  v-else v-html="post.excerpt"></p>
            <div class="has-text-right pt-3">
                <social-sharing v-bind:url="curr_path+'/post/'+ post._id" v-bind:hashtags="hashtag" v-bind:title="post.title+' 👉 '" inline-template>
                    <div>
                        <network network="facebook">
                            <b-icon icon="facebook" size="is-medium" type="is-primary"></b-icon>
                        </network><span style="visibility: hidden;">|||</span>
                        <network network="twitter">
                            <b-icon icon="twitter" size="is-medium" type="is-primary"></b-icon>
                        </network>
                    </div>
                </social-sharing>
            </div>
        </div>

<div class="has-text-right">
        <router-link class="mt-4 button is-danger is-normal" to="/actualites#top">Voir toutes les actualités</router-link>
        </div>

    </div>
</template>
<script>
const axios = require('axios');
var SocialSharing = require('vue-social-sharing');
import NotFound from './NotFound.vue';

export default {
    data: function() {
        return {
            loading: true,
            post: null,
            error: null,
            curr_path: window.location.origin,
            hashtag: this.$share_hashtag,
            maintitle: 'Actualité',
        }
    },
    components: {
        SocialSharing,
        NotFound
    },
    name: 'Post',
    props: {
        msg: String
    },
    created() {
        this.fetchData()
    },
    updated() {
        this.maintitle = this.page ? this.page.title : this.maintitle;
    },
    watch: {
        // call again the method if the route changes
        '$route': 'fetchData'
    },
    methods: {
        imageUrlAlt(event) {
            event.target.src = "https://buefy.org/static/img/placeholder-1280x960.png"
        },
        fetchData() {
            this.error = this.post = null
            this.loading = true
            var vm = this
            //var fetchurl = this.$api_url_posts
            var fetchurl = this.$api_url_posts+'&sort[datepost]=-1&limit=1&populate=1&filter[_id]='+encodeURIComponent(vm.$route.params.id)
            axios({
                    method: 'get',
                    url: fetchurl,
                    /*headers: { 'Content-Type': 'application/json' },
                    data: JSON.stringify({
                        filter: { _id: vm.$route.params.id },
                        //fields: {fieldA:1},
                        limit: 1,
                        sort: { datepost: -1 },
                        populate: 1, // resolve linked collection items
                        lang: 'fr' // return normalized language fields (fieldA_de => fieldA)
                    })*/
                }).then(function(response) {
                    vm.loading = false
                    if (response.data.entries.length > 0) {
                        vm.post = response.data.entries[0]
                        vm.error = null
                    } else {
                        vm.post = null
                        vm.error = 'page introuvable'
                    }
                })
                .catch(function() {
                    //console.log("Erreur ! Impossible d'accéder à l'API." + error)
                    vm.error = 'page introuvable'
                })

        }
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.blogpost {
    border-radius: 0px;
    border-left: 12px solid #ff3860;
    box-shadow: 1px 1px 12px #555;
}
.post{
    margin-bottom: 100px;
    margin-top: 100px;
}

div {
  word-wrap: break-word;
}

@media only screen and (max-width: 600px) {
  .post {
    margin-bottom: 50px;
    margin-top: 50px;
  }
}
</style>